/**
 * Get the full asset path including the base URL
 * Use this for all public assets (images, videos, etc.)
 */
export const asset = (path: string): string => {
    const base = import.meta.env.BASE_URL || '/';

    const cleanPath = path.startsWith('/') ? path.slice(1) : path;

    return `${base}${cleanPath}`;
};
